"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import type { AppLocale } from "@/core/i18n/config";
import { useBookingStepperStore } from "../../states/booking-stepper.store";
function formatRemaining(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

/**
 * Shows a live countdown for the active slot hold and returns the seeker to
 * step 3 (with a toast) if the hold expires before they finish the flow.
 */
export function HoldCountdown(t0) {
  const $ = _c(12);
  const {
    locale
  } = t0;
  const isHindi = locale === "hi";
  const holdExpiresAt = useBookingStepperStore(_temp);
  const step = useBookingStepperStore(_temp2);
  const resetHold = useBookingStepperStore(_temp3);
  const [remainingMs, setRemainingMs] = useState(null);
  let t1;
  let t2;
  if ($[0] !== holdExpiresAt || $[1] !== isHindi || $[2] !== resetHold || $[3] !== step) {
    t1 = () => {
      if (!holdExpiresAt || step < 4) {
        return;
      }
      const expiresAt = new Date(holdExpiresAt).getTime();
      const tick = function tick() {
        const remaining = expiresAt - Date.now();
        setRemainingMs(remaining);
        if (remaining <= 0) {
          toast.error(isHindi ? "\u0906\u092A\u0915\u093E \u0938\u094D\u0932\u0949\u091F \u0939\u094B\u0932\u094D\u0921 \u0938\u092E\u093E\u092A\u094D\u0924 \u0939\u094B \u0917\u092F\u093E\u0964 \u0915\u0943\u092A\u092F\u093E \u092B\u093F\u0930 \u0938\u0947 \u0938\u092E\u092F \u091A\u0941\u0928\u0947\u0902\u0964" : "Your slot hold expired. Please choose a time again.");
          resetHold();
        }
      };
      tick();
      const interval = setInterval(tick, 1000);
      return () => clearInterval(interval);
    };
    t2 = [holdExpiresAt, step, resetHold, isHindi];
    $[0] = holdExpiresAt;
    $[1] = isHindi;
    $[2] = resetHold;
    $[3] = step;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (remainingMs == null || step < 4 || !holdExpiresAt) {
    return null;
  }
  const isLow = remainingMs < 60000;
  const t3 = `mb-4 rounded-xl px-4 py-2.5 text-center text-sm font-semibold ${isLow ? "bg-red-50 text-red-600" : "bg-[#155A7D]/10 text-[#155A7D]"}`;
  const t4 = isHindi ? "\u0906\u092A\u0915\u093E \u0938\u094D\u0932\u0949\u091F \u0939\u094B\u0932\u094D\u0921 \u0939\u0948:" : "Your slot is held for:";
  let t5;
  if ($[6] !== remainingMs) {
    t5 = formatRemaining(remainingMs);
    $[6] = remainingMs;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t3}>{t4} {t5}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp3(state_1) {
  return state_1.resetHold;
}
function _temp2(state_0) {
  return state_0.step;
}
function _temp(state) {
  return state.holdExpiresAt;
}